// 講座時程表資料（先寫死，之後有 API 再替換）
export const lectureScheduleDays = [
  {
    year: 2026,
    month: '9',
    date: '12',
    weekday: '六',
    sessions: [
      {
        classNumber: 1,
        class: '1-1',
        time: '10:30-11:00',
        title: '承先啟後 正法久住',
        subtitle: '一 新世代弘法的時代適應之道',
        speaker: { title: '中台禪寺法務副住持', name: '見劍法師' },
      },
      {
        classNumber: 1,
        class: '1-2',
        time: '11:00-11:30',
        title: '般若叮叮車：彼此照亮的旅程',
        subtitle: '一 以「和合」引領護法團隊',
        speaker: { title: '普廣精舍住持法師', name: '見脈法師' },
      },
      {
        classNumber: 2,
        class: '2-1',
        time: '14:30-15:00',
        title: '慧眼識英雄',
        subtitle: '一 人才的選用育留',
        speaker: { title: '普高精舍執行秘書', name: '丘曉月' },
      },
      {
        classNumber: 2,
        class: '2-2',
        time: '15:00-15:30',
        title: '從「資深」到「新生」',
        subtitle: '一 打造跨世代的護法團隊',
        speaker: { title: '普真精舍執行秘書', name: '黃貞儒' },
      },
    ],
  },
  {
    year: 2026,
    month: '9',
    date: '13',
    weekday: '日',
    sessions: [
      {
        classNumber: 3,
        class: '3-1',
        time: '09:00-09:30',
        title: '在慢活的土地上•讓佛法深根',
        speaker: { title: '普門精舍住持法師', name: '見慇法師' },
      },
      {
        classNumber: 3,
        class: '3-2',
        time: '09:30-10:00',
        title: '弘法不設限~環境、空間、尋解方',
        speaker: { title: '普宏精舍攝影組組長', name: '蘇俊昌' },
      },
      {
        classNumber: 4,
        class: '4',
        time: '11:00-11:30',
        title: '小護法養成記',
        speaker: { title: '普濟精舍副會長', name: '侯鳴蟬' },
      },
      {
        classNumber: 5,
        class: '5-1',
        time: '14:00-14:30',
        title: '精舍緊急事件處理應變SOP',
        speaker: { title: '中台禪寺醫護中心長期義工', name: '郭翠玫' },
      },
      {
        classNumber: 5,
        class: '5-2',
        time: '14:30-15:00',
        title: '來來來的N次方',
        subtitle: '一 自發性團隊的運轉心法',
        speaker: { title: '普賢精舍副會長', name: '許慈美' },
      },
    ],
  },
]
